export const text = `Click the giftbox to open some presents.`;
